import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

const DocumentIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M6 2h8.5L19 6.5V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z" />
    <path d="M14.5 2.5V7a1 1 0 0 0 1 1h4.5" />
    <path d="M8 13h8M8 17h6" />
  </SvgIcon>
);

export default DocumentIcon;
